module.exports = {
  apiUrlTools: [
    "https://toolsapi.express.gls.dk"
    // "https://toolsapitest.express.gls.dk"
    // "https://localhost:5001"
  ],
  apiUrlDirections: [
    "https://directionsapi.express.gls.dk"
    // "https://glsexpressdirectionsapitest.gls.dk"
    // "https://localhost:5001"
  ],
  apiUrlPrice: [
    "https://priceapi.express.gls.dk"
    // "https://priceapitest.express.gls.dk"
    // "https://localhost:5001"
  ],
  apiUrlBooking_BookingEndpoint: [
    "https://bookingapi.express.gls.dk/BOOKINGAPI"
    // "https://bookingapi.express.gls.dk:8443/BOOKINGAPITEST"
    // 'https://localhost:5001',
  ],
  apiUrlBooking_PriceEndpoint: [
    "https://bookingapi.express.gls.dk/BOOKINGAPI"
    // "https://bookingapi.express.gls.dk:8443/BOOKINGAPITEST"
    // 'https://localhost:5001',
  ],
  adressevaelgerUrl: "https://adressevaelger.dk",
  adressevaelgerToken: "adressevaelger123",
  bookingAPIPwd: "n3ww3bb00k!ngpr!c3calcul3t!0n_2021_",
  apiKey: "AIzaSyCs1HyoB88r2rksLVRZ8Mv3S436vvXKgAM"
};
